import { createApp } from 'vue'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap'
import i18n, { loadLocaleMessages } from './i18n'

// Setup axios interceptors globally
axios.interceptors.request.use(
  (config) => {
    store.dispatch('setLoading', true)
    return config
  },
  (error) => {
    store.dispatch('setLoading', false)
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  (response) => {
    store.dispatch('setLoading', false)
    return response
  },
  (error) => {
    store.dispatch('setLoading', false)
    return Promise.reject(error)
  }
)

async function initApp() {
  const savedLocale = store.getters.currentLocale
  const browserLang = navigator.language.split('-')[0] || 'en'
  await loadLocaleMessages(savedLocale || browserLang)

  createApp(App).use(store).use(router).use(i18n).mount('#app')
}

initApp()
